<template>
    <div class="request-quote">
        <header>
            <img loading="lazy" src="../../assets/Chery-Slider-Image-1.webp" alt="top header cover">
        </header>

        
        <div class="container">
            <h1>Request a Quote</h1>
            
            <div class="block">
                <div v-if="theRes.length != 0" style="width: 100%;
                            border-radius: 10px;
                            padding: 1.2em;
                            text-transform: capitalize;
                            background: var(--noble-gold2);
                            border: 2px solid var(--noble-gold);
                            color: var(--tech-black);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;">
                    {{ theRes}}

                    <button style="color: var(--tech-black);" @click="theRes=''">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </button>
                 </div>
                <!-- personal details -->
                <div class="form">
                    <div>
                        <label class="title" for="username">Full Name</label>
                        <input v-model="name" id="username" type="text" placeholder="Full name">
                        <span class="errorTxt" v-if="errors.name.length>1"> {{ errors.name }}</span>
                    </div>

                    <div>
                        <label class="title" for="email">Email</label>
                        <input v-model="email" type="email" placeholder="example@xyz.com">
                        <span class="errorTxt" v-if="errors.email.length>1"> {{ errors.email }}</span>
                    </div>

                    <div>
                        <label class="title" for="phone">Phone Number</label>
                        <input v-model="phone" type="text" placeholder="+218-9x-xxxxxxx">
                        <span class="errorTxt" v-if="errors.phone.length>1"> {{ errors.phone }}</span>
                    </div>
                </div>

                <!-- city / car model -->
                <div class="form">
                    <!-- city -->
                    <div v-if="false">
                        <label class="title">Select a city</label>
                        
                        <div class="selected" @click="cityMenu= !cityMenu; carMenu=false">
                            {{ selectedCity }}
                            <svg :style="{transform: cityMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="cityMenu">
                                <span v-for="city in cities" :key="city" @click="selectedCity=city; cityMenu=false">{{ city }}</span>
                            </div>
                        </transition>
                    </div>

                    <!-- car model -->
                    <div>
                        <label class="title">Select a Car</label>
                        
                        <div class="selected" @click="carMenu= !carMenu; cityMenu=false">
                            {{ selectedCar }}
                            <svg :style="{transform: carMenu ? 'rotate(180deg)':'rotate(0deg)'}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                        </div>
                        <span class="errorTxt"> {{ errors.model }}</span>

                        <transition name="slide" mode="out-in" appear>
                            <div class="menu" v-if="carMenu">
                                <span v-for="car in cars" :key="car.name" @click="selectedCar=car.value; carMenu=false">{{ car.name }}</span>
                            </div>
                        </transition>
                    </div>

                </div>
                
            </div> 
            
            <div class="cta">
                <div class="g-recaptcha" 
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired"
                    data-sitekey="6LezQ64nAAAAABJ_1jDbMwjTWn07462potaAZN16"></div>

                <button class="square" @click="sendRequestQoute">submit</button>
            </div>
            <span style="color: red;" class="errorTxt" v-if="errors.captcha.length>1">{{ errors.captcha }}</span>
        </div>
    </div>
</template>

<script>
/* global grecaptcha */
import api from '@/apis';

    export default {
        data() {
            return {
                captchaToken: "", // store token here
                recaptchaWidgetId: null,
                phone: "",
                email: "",
                name: "",
                errors: {
                    name: "",
                    email: "",
                    phone: "",
                    model: "",
                    captcha: ""
                },
                theRes: "",
                selectedCity: "Tripoli",
                selectedCar: "Select a model",
                carMenu: false,
                cityMenu: false,
                cities: [
                    "Tripoli",
                    "Zlitan",
                    "Misurata",
                    "Benghazi",
                    "AlBayda"
                ],
                cars: []
            }
        },
        methods: {
            fetchCarsNames() {
                api.get("models/names")
                .then(res => {
                    this.cars = res.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
            },
            validateForm() {
                // reset errors
                this.errors.name = "";
                this.errors.email = "";
                this.errors.phone = "";
                this.errors.model = "";

                let isValid = true;

                // NAME
                if (!this.name.trim()) {
                    this.errors.name = "Name is required";
                    isValid = false;
                } else if (this.name.length < 3) {
                    this.errors.name = "Name must be at least 3 characters";
                    isValid = false;
                }

                // EMAIL
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // PHONE
                const phoneRegex = /^[0-9]{9,15}$/;
                if (!this.phone.trim()) {
                    this.errors.phone = "Phone number is required";
                    isValid = false;
                } else if (!phoneRegex.test(this.phone)) {
                    this.errors.phone = "Phone must be 9–15 digits";
                    isValid = false;
                }

                // MODEL
                const modelRegex = /^[A-Za-z0-9 _-]{2,100}$/;
                if (!this.selectedCar || this.selectedCar == "Select a model" ) {
                    this.errors.model = "Model is required";
                    isValid = false;
                } else if (!modelRegex.test(this.selectedCar)) {
                    this.errors.model = "Model name is invalid";
                    isValid = false;
                }

                return isValid;
            },
            sendRequestQoute() {
                
                this.errors.captcha = "";

                if (!this.validateForm()) {return;}
                if (!this.captchaToken) {
                    this.errors.captcha = "Please complete the captcha.";
                    return;
                }

                api.post("/request_quote?locale=en", {
                    name: this.name,
                    phone: this.phone.replace(/^\+/, ""),
                    model: this.selectedCar,
                    email: this.email,
                    'g-recaptcha-response': this.captchaToken // <-- this is critical
                })
                .then(res => {
                    this.theRes = res.data.message;
                    this.phone = "";
                    this.email = "";
                    this.name = "";
                    this.selectedCar = "Select a model";

                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }
                })
                .catch(error => {

                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }

                    
                    // GLOBAL GUARD
                    if (!error.response ||
                        error.response.status !== 422 ||
                        !error.response.data ||
                        !error.response.data.errors) {
                        // not a validation error → ignore field mapping
                        return;
                    }

                    const backendErrors = error.response.data.errors;

                    // reset errors
                    this.errors.name = "";
                    this.errors.email = "";
                    this.errors.phone = "";
                    this.errors.model = "";

                    // map backend errors safely
                    Object.keys(this.errors).forEach(field => {
                        if (backendErrors[field]) {
                        this.errors[field] = backendErrors[field][0];
                        }
                    });
                });


            },
        },
        mounted() {
            this.fetchCarsNames();
            // reCAPTCHA calls these global functions
            window.onCaptchaVerified = (token) => {
                this.captchaToken = token;
                console.log("✅ CAPTCHA verified:", token);
            };

            window.onCaptchaExpired = () => {
                this.captchaToken = null;
                // console.log("⚠️ CAPTCHA expired");
            };
        },
        beforeDestroy() {
            // Clean up to avoid memory leaks
            delete window.onCaptchaVerified;
            delete window.onCaptchaExpired;
        },

    }
</script>